<template>
  <div class="install-view">
    <div class="dialog" role="dialog" aria-live="polite" aria-label="Install app prompt">
      <h1>Install Lunchlytics</h1>

      <p>Install Lunchlytics for quick access!</p>
      <button
          class="btn-primary"
          @click="installApp"
          aria-label="Install Lunchlytics app"
      >
        Install
      </button>
      <button class="cancel-btn" @click="cancel">Cancel</button>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { deferredPrompt } from '../stores/deferredPromptStore.ts'

const router = useRouter()

const installApp = async () => {
  if (!deferredPrompt.value) return
  deferredPrompt.value.prompt()
  const choice = await deferredPrompt.value.userChoice
  if (choice.outcome === 'accepted') {
    console.log('PWA installed')
  }
  deferredPrompt.value = null
}

const cancel = () => {
  router.back()
}
</script>

<style scoped>
.install-view {
  position: fixed;
  inset: 0;
  background-color: rgba(18, 18, 18, 0.85); /* darker overlay */
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  z-index: 10000;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  color: #ddd;
}

.dialog {
  background: #2a2a2a;
  padding: 2rem 3rem;
  border-radius: 12px;
  max-width: 400px;
  width: 100%;
  box-shadow: 0 0 2px rgba(182, 196, 181, 0.6);
  text-align: center;
  color: #ddd;
}

h1 {
  margin-bottom: 1rem;
  color: #8dbc05;
}

p {
  margin-bottom: 2rem;
  font-size: 1.1rem;
  color: #bbb;
}

.btn-primary {
  background-color: #8dbc05;
  color: #121212;
  border: none;
  padding: 0.6rem 1.2rem;
  border-radius: 8px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  margin: 0 0.5rem;
  transition: background-color 0.3s ease;
}

.btn-primary:disabled {
  background-color: #a9bb6f;
  cursor: not-allowed;
  color: #444;
}

.btn-primary:hover:not(:disabled) {
  background-color: #81a905;
}

.cancel-btn {
  background-color: #2f2f2f;
  color: #a0aec0;
  border: 1px solid #4a5568;
  padding: 0.6rem 1.2rem;
  border-radius: 8px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  margin: 0 0.5rem;
  transition: background-color 0.3s ease;
}

.cancel-btn:hover {
  background-color: #444444;
}
</style>

